(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jewellery-listing-page"] && !Shopify.designMode) return;
  try {
    
  const initJewelleryPage = (page) => {
    if (page.dataset.jewelleryPageInitialized === 'true') return;

    const priceFilter = page.querySelector('[data-price-filter]');
    const priceOutput = page.querySelector('[data-price-selected-output]');
    const colorFilters = page.querySelectorAll('[data-color-filter]');
    const shapeFilters = page.querySelectorAll('[data-shape-filter]');
    const clearButton = page.querySelector('[data-clear-filters]');
    const sortSelect = page.querySelector('[data-sort-products]');
    const productsGrid = page.querySelector('[data-products-grid]');
    const cards = Array.from(page.querySelectorAll('[data-product-card]'));
    const filterDrawer = page.querySelector('[data-filter-drawer]');
    const filterToggle = page.querySelector('[data-filter-toggle]');
    const filterCloseButtons = page.querySelectorAll('[data-filter-close]');
    const wishlistStorageKey = 'raza-gems-wishlist';
    const wishlistButtons = page.querySelectorAll('[data-jewellery-wishlist]');
    const mobileMedia = window.matchMedia('(max-width: 1100px)');
    let filterToggleReturn = null;

    if (!filterToggle || !filterDrawer) return;

    page.dataset.jewelleryPageInitialized = 'true';

    const getWishlist = () => JSON.parse(localStorage.getItem(wishlistStorageKey) || '[]');
    const setWishlist = (wishlist) => localStorage.setItem(wishlistStorageKey, JSON.stringify(wishlist));

    const closeFilterDrawer = () => {
      page.classList.remove('is-filter-drawer-open');
      filterToggle?.setAttribute('aria-expanded', 'false');

      if (filterDrawer) {
        filterDrawer.setAttribute('aria-hidden', mobileMedia.matches ? 'true' : 'false');
      }

      document.documentElement.classList.remove('jewellery-filter-drawer-open');

      if (filterToggleReturn instanceof HTMLElement) {
        filterToggleReturn.focus();
      }
    };

    const openFilterDrawer = () => {
      filterToggleReturn = document.activeElement;
      page.classList.add('is-filter-drawer-open');
      filterToggle?.setAttribute('aria-expanded', 'true');
      filterDrawer?.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('jewellery-filter-drawer-open');
      filterDrawer?.querySelector('[data-filter-close]')?.focus();
    };

    const syncWishlistButtons = () => {
      const wishlist = getWishlist();

      wishlistButtons.forEach((button) => {
        const active = wishlist.some((item) => item.handle === button.dataset.productHandle);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
      });
    };

    const selectedValues = (inputs) => {
      return Array.from(inputs)
        .filter((input) => input.checked)
        .map((input) => input.value);
    };

    const applyFilters = () => {
      if (!priceFilter) return;

      const maxPrice = Number(priceFilter.value);
      const minPrice = Number(priceFilter.min);
      const rangeMax = Number(priceFilter.max);
      const progress = rangeMax > minPrice ? ((maxPrice - minPrice) / (rangeMax - minPrice)) * 100 : 100;
      priceFilter.style.setProperty('--catalog-price-progress', `${progress}%`);
      const colors = selectedValues(colorFilters);
      const shapes = selectedValues(shapeFilters);

      if (priceOutput) {
        priceOutput.textContent = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: page.dataset.currency
        }).format(maxPrice);
      }

      cards.forEach((card) => {
        const price = Number(card.dataset.price);
        const color = card.dataset.color;
        const shape = card.dataset.shape;
        const priceMatches = price <= maxPrice;
        const colorMatches = colors.length === 0 || colors.includes(color);
        const shapeMatches = shapes.length === 0 || shapes.includes(shape);

        card.classList.toggle('is-hidden', !(priceMatches && colorMatches && shapeMatches));
      });
    };

    const sortProducts = () => {
      const sortedCards = [...cards];

      sortedCards.sort((firstCard, secondCard) => {
        if (sortSelect.value === 'title-ascending') {
          return firstCard.dataset.title.localeCompare(secondCard.dataset.title);
        }
        if (sortSelect.value === 'title-descending') {
          return secondCard.dataset.title.localeCompare(firstCard.dataset.title);
        }

        if (sortSelect.value === 'price-ascending') {
          return Number(firstCard.dataset.price) - Number(secondCard.dataset.price);
        }

        if (sortSelect.value === 'price-descending') {
          return Number(secondCard.dataset.price) - Number(firstCard.dataset.price);
        }

        return cards.indexOf(firstCard) - cards.indexOf(secondCard);
      });

      sortedCards.forEach((card) => productsGrid.appendChild(card));
    };

    priceFilter?.addEventListener('input', applyFilters);
    colorFilters.forEach((input) => input.addEventListener('change', applyFilters));
    shapeFilters.forEach((input) => input.addEventListener('change', applyFilters));
    sortSelect?.addEventListener('change', sortProducts);
    filterToggle?.addEventListener('click', openFilterDrawer, { capture: true });
    filterCloseButtons.forEach((button) => button.addEventListener('click', closeFilterDrawer));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && page.classList.contains('is-filter-drawer-open')) {
        closeFilterDrawer();
      }
    });

    mobileMedia.addEventListener('change', () => {
      if (mobileMedia.matches) {
        filterDrawer?.setAttribute('aria-hidden', page.classList.contains('is-filter-drawer-open') ? 'false' : 'true');
      } else {
        closeFilterDrawer();
        filterDrawer?.setAttribute('aria-hidden', 'false');
      }
    });

    if (filterDrawer) {
      filterDrawer.setAttribute('aria-hidden', mobileMedia.matches ? 'true' : 'false');
    }

    wishlistButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const product = {
          handle: button.dataset.productHandle,
          title: button.dataset.productTitle,
          url: button.dataset.productUrl,
        image: button.dataset.productImage,
        price: button.dataset.productPrice,
        variantId: button.dataset.productVariantId,
        color: button.dataset.productColor,
        shape: button.dataset.productShape,
        type: button.dataset.productGemstoneType,
        gemstoneType: button.dataset.productGemstoneType,
        productType: button.dataset.productType,
      };

        if (!product.handle) return;

        const wishlist = getWishlist();
        const existingIndex = wishlist.findIndex((item) => item.handle === product.handle);
        const isSaved = existingIndex === -1;

        if (existingIndex >= 0) {
          wishlist.splice(existingIndex, 1);
        } else {
          wishlist.unshift(product);
        }

        setWishlist(wishlist);
        syncWishlistButtons();
        window.dispatchEvent(
          new CustomEvent('raza-gems:wishlist-updated', {
            detail: {
              count: wishlist.length,
              saved: isSaved,
              handle: product.handle,
            },
          })
        );
      });
    });

    clearButton?.addEventListener('click', () => {
      priceFilter.value = priceFilter.max;
      colorFilters.forEach((input) => {
        input.checked = false;
      });
      shapeFilters.forEach((input) => {
        input.checked = false;
      });
      applyFilters();
    });

    if (priceFilter) {
      applyFilters();
    }

    syncWishlistButtons();
    window.addEventListener('raza-gems:wishlist-updated', syncWishlistButtons);
  };

  const initJewelleryPages = (root = document) => {
    if (root.matches?.('[data-jewellery-page]')) {
      initJewelleryPage(root);
    }

    root.querySelectorAll('[data-jewellery-page]').forEach(initJewelleryPage);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initJewelleryPages(), { once: true });
  } else {
    initJewelleryPages();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initJewelleryPages(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  const buildArticleToc = (root = document) => {
    const articleContent = root.querySelector('[data-article-content]');
    const tocList = root.querySelector('[data-article-toc-list]');
    if (!articleContent || !tocList) return;

    tocList.replaceChildren();
    const usedIds = new Set([...articleContent.querySelectorAll('[id]')].map((element) => element.id));
    const headings = [...articleContent.querySelectorAll('h2, h3')];
    headings.forEach((heading, index) => {
      const title = heading.textContent.trim();
      if (!title) return;

      let id = heading.id;
      if (!id) {
        const slug = title.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${index + 1}`;
        id = `article-${slug}`;
        let suffix = 2;
        while (usedIds.has(id)) id = `article-${slug}-${suffix++}`;
        heading.id = id;
        usedIds.add(id);
      }

      const item = document.createElement('li');
      item.className = `article-toc__item article-toc__item--${heading.tagName.toLowerCase()}`;
      const link = document.createElement('a');
      link.href = `#${encodeURIComponent(id)}`;
      link.textContent = title;
      item.append(link);
      tocList.append(item);
    });
  };

  const initializeArticleSections = (root = document) => {
    root.querySelectorAll('[data-article-toc]').forEach((toc) => {
      buildArticleToc(toc.closest('.shopify-section') || root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeArticleSections(), { once: true });
  } else {
    initializeArticleSections();
  }
  document.addEventListener('shopify:section:load', (event) => initializeArticleSections(event.target));
  const relatedList = document.querySelector('.article-related__list');
  const relatedItems = relatedList ? [...relatedList.querySelectorAll('[data-related-item]')] : [];
  const relatedMore = document.querySelector('[data-related-more]');
  if (relatedList && relatedItems.length) {
    relatedItems.forEach((item, index) => {
      item.hidden = index >= 4;
    });
    if (relatedItems.length > 4 && relatedMore) relatedMore.hidden = false;
    relatedMore?.addEventListener('click', () => {
      const hiddenItems = relatedItems.filter((item) => item.hidden).slice(0, 4);
      hiddenItems.forEach((item) => { item.hidden = false; });
      if (!relatedItems.some((item) => item.hidden) && relatedMore) relatedMore.hidden = true;
    });
  }
  const relatedPromo = document.querySelector('.article-related-promo');
  const relatedPromoImage = relatedPromo?.querySelector('img');
  const relatedPromoOptions = relatedPromo ? [...relatedPromo.querySelectorAll('[data-related-promo-option]')] : [];
  if (relatedPromo?.dataset.randomize === 'true' && relatedPromoImage && relatedPromoOptions.length) {
    const option = relatedPromoOptions[Math.floor(Math.random() * relatedPromoOptions.length)];
    relatedPromoImage.src = option.dataset.src;
    relatedPromoImage.srcset = option.dataset.srcset;
    relatedPromoImage.width = option.dataset.width;
    relatedPromoImage.height = option.dataset.height;
    relatedPromoImage.alt = option.dataset.alt || '';
    relatedPromo.href = option.dataset.url || relatedPromo.href;
  }
  const tocPromo = document.querySelector('.article-toc-promo');
  const tocPromoImage = tocPromo?.querySelector('img');
  const tocPromoOptions = tocPromo ? [...tocPromo.querySelectorAll('[data-related-promo-option]')] : [];
  if (tocPromo && tocPromoImage && tocPromoOptions.length) {
    const option = tocPromoOptions[Math.floor(Math.random() * tocPromoOptions.length)];
    tocPromoImage.src = option.dataset.src;
    tocPromoImage.srcset = option.dataset.srcset;
    tocPromoImage.width = option.dataset.width;
    tocPromoImage.height = option.dataset.height;
    tocPromoImage.alt = option.dataset.alt || '';
    tocPromo.href = option.dataset.url || tocPromo.href;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sales"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const handle = (value) => String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

    const initSalesPage = (page) => {
      if (page.dataset.salesPageInitialized === 'true') return;
      page.dataset.salesPageInitialized = 'true';

      const items = Array.from(page.querySelectorAll('[data-sales-item]'));
      const grid = page.querySelector('[data-sales-grid]');
      const count = page.querySelector('[data-sales-count]');
      const empty = page.querySelector('[data-sales-empty]');
      const sort = page.querySelector('[data-sales-sort]');
      const priceMaxRange = page.querySelector('[data-sales-price-max-range]');
      const priceRange = page.querySelector('[data-sales-price-range]');
      const priceMinLabel = page.querySelector('[data-sales-price-min-label]');
      const priceMaxLabel = page.querySelector('[data-sales-price-max-label]');
      const priceSelectedLabel = page.querySelector('[data-sales-price-selected-label]');
      const clearButtons = page.querySelectorAll('[data-sales-clear]');
      const drawer = page.querySelector('[data-sales-filter-drawer]');
      const filterToggle = page.querySelector('[data-sales-filter-toggle]');
      const filterCloseButtons = page.querySelectorAll('[data-sales-filter-close]');
      const mobileMedia = window.matchMedia('(max-width: 900px)');
      let filterToggleReturn = null;

      // Keep every Sales filter expanded on initial render, including after a refresh
      // where the browser may restore a previously collapsed details state.
      page.querySelectorAll('.sales-filter').forEach((filter) => {
        filter.open = true;
        filter.addEventListener('toggle', () => {
          if (!filter.open) filter.open = true;
        });
      });

      const state = {
        productType: new Set(),
        discount: new Set(),
        gemstoneType: new Set(),
        shape: new Set(),
        color: new Set(),
        min: null,
        max: null,
        sort: 'discount-desc',
      };

      const prices = items.map((item) => Number(item.dataset.price || 0) / 100).filter((price) => Number.isFinite(price) && price >= 0);
      const minPrice = prices.length ? Math.min(...prices) : 0;
      const maxPrice = prices.length ? Math.max(...prices) : 0;

      if (priceMaxRange) {
        priceMaxRange.min = minPrice;
        priceMaxRange.max = maxPrice;
        priceMaxRange.step = 0.01;
        priceMaxRange.value = maxPrice;
      }

      const closeDrawer = () => {
        page.classList.remove('is-filter-drawer-open');
        filterToggle?.setAttribute('aria-expanded', 'false');
        drawer?.setAttribute('aria-hidden', mobileMedia.matches ? 'true' : 'false');
        document.documentElement.classList.remove('sales-filter-drawer-open');
        if (filterToggleReturn instanceof HTMLElement) filterToggleReturn.focus();
      };

      const openDrawer = () => {
        if (!mobileMedia.matches) return;
        filterToggleReturn = document.activeElement;
        page.classList.add('is-filter-drawer-open');
        filterToggle?.setAttribute('aria-expanded', 'true');
        drawer?.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('sales-filter-drawer-open');
        drawer?.querySelector('[data-sales-filter-close]')?.focus();
      };

      const makeOptions = (keyAttr, labelAttr = keyAttr) => {
        const map = new Map();
        items.forEach((item) => {
          const key = item.dataset[keyAttr];
          const label = item.dataset[labelAttr];
          if (!key || !label) return;
          const entry = map.get(key) || { key, label, count: 0 };
          entry.count += 1;
          map.set(key, entry);
        });
        return Array.from(map.values()).sort((a, b) => a.label.localeCompare(b.label));
      };

      const discountRanges = [
        { key: 'up-to-10', label: 'Up to 10% Off', min: 0, max: 10 },
        { key: '10-20', label: '10% - 20% Off', min: 10, max: 20 },
        { key: '20-30', label: '20% - 30% Off', min: 20, max: 30 },
        { key: '30-50', label: '30% - 50% Off', min: 30, max: 50 },
        { key: '50-plus', label: '50%+ Off', min: 50, max: Infinity },
      ].map((range) => ({
        ...range,
        count: items.filter((item) => {
          const discount = Number(item.dataset.discount || 0);
          return discount > range.min && discount <= range.max;
        }).length,
      }));

      const optionGroups = {
        productType: makeOptions('productTypeKey', 'productType'),
        discount: discountRanges,
        gemstoneType: makeOptions('gemstoneTypeKey', 'gemstoneType'),
        shape: makeOptions('shapeKey', 'shape'),
        color: makeOptions('colorKey', 'color'),
      };

      Object.entries(optionGroups).forEach(([group, options]) => {
        const target = page.querySelector(`[data-sales-options="${group}"]`);
        if (!target) return;
        target.innerHTML = options.filter((option) => option.count > 0).map((option) => `
          <label class="sales-filter__option">
            <input type="checkbox" value="${option.key}" data-sales-check="${group}">
            <span></span>
            <em>${option.label} (${option.count})</em>
          </label>
        `).join('');
      });

      const updatePriceRangeTrack = () => {
        if (!priceRange || !priceMaxRange) return;
        const maxValue = Number(priceMaxRange.value || maxPrice);
        const end = maxPrice > minPrice ? ((maxValue - minPrice) / (maxPrice - minPrice)) * 100 : 100;
        priceMaxRange.style.setProperty('--catalog-price-progress', `${end}%`);
        if (priceMinLabel) priceMinLabel.textContent = `Rs. ${formatMoney.format(minPrice)}`;
        if (priceMaxLabel) priceMaxLabel.textContent = `Rs. ${formatMoney.format(maxPrice)}`;
        if (priceSelectedLabel) priceSelectedLabel.textContent = `Rs. ${formatMoney.format(maxValue)}`;
      };

      const syncPriceControls = () => {
        let max = Number(priceMaxRange?.value || maxPrice);
        max = Math.max(minPrice, Math.min(max, maxPrice));
        state.min = minPrice;
        state.max = max;
        if (priceMaxRange) priceMaxRange.value = max;
        updatePriceRangeTrack();
      };

      const matchesDiscount = (item) => {
        if (!state.discount.size) return true;
        const discount = Number(item.dataset.discount || 0);
        return Array.from(state.discount).some((key) => {
          const range = discountRanges.find((entry) => entry.key === key);
          return range && discount > range.min && discount <= range.max;
        });
      };

      const apply = () => {
        syncPriceControls();
        let visible = items.filter((item) => {
          const price = Number(item.dataset.price || 0) / 100;
          return (!state.productType.size || state.productType.has(item.dataset.productTypeKey))
            && matchesDiscount(item)
            && (!state.gemstoneType.size || state.gemstoneType.has(item.dataset.gemstoneTypeKey))
            && (!state.shape.size || state.shape.has(item.dataset.shapeKey))
            && (!state.color.size || state.color.has(item.dataset.colorKey))
            && price >= state.min
            && price <= state.max;
        });

        visible.sort((a, b) => {
          if (state.sort === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
          if (state.sort === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
          if (state.sort === 'title-asc') return a.dataset.title.localeCompare(b.dataset.title);
          if (state.sort === 'title-desc') return b.dataset.title.localeCompare(a.dataset.title);
          return Number(b.dataset.discount) - Number(a.dataset.discount);
        });

        items.forEach((item) => { item.hidden = true; });
        visible.forEach((item) => {
          item.hidden = false;
          grid.appendChild(item);
        });

        count.textContent = `${visible.length} products`;
        empty.hidden = visible.length > 0;
      };

      page.addEventListener('change', (event) => {
        const checkbox = event.target.closest('[data-sales-check]');
        if (checkbox) {
          const group = checkbox.dataset.salesCheck;
          checkbox.checked ? state[group].add(checkbox.value) : state[group].delete(checkbox.value);
        }
        if (event.target === sort) state.sort = sort.value;
        apply();
      });

      page.addEventListener('input', (event) => {
        if (event.target === priceMaxRange) apply();
      });

      clearButtons.forEach((button) => {
        button.addEventListener('click', () => {
          Object.values(state).forEach((value) => {
            if (value instanceof Set) value.clear();
          });
          state.sort = 'discount-desc';
          if (sort) sort.value = state.sort;
          if (priceMaxRange) priceMaxRange.value = maxPrice;
          page.querySelectorAll('[data-sales-check]').forEach((checkbox) => { checkbox.checked = false; });
          apply();
        });
      });

      filterToggle?.addEventListener('click', openDrawer);
      filterCloseButtons.forEach((button) => button.addEventListener('click', closeDrawer));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && page.classList.contains('is-filter-drawer-open')) closeDrawer();
      });
      mobileMedia.addEventListener('change', () => {
        if (mobileMedia.matches) {
          drawer?.setAttribute('aria-hidden', page.classList.contains('is-filter-drawer-open') ? 'false' : 'true');
        } else {
          closeDrawer();
          drawer?.setAttribute('aria-hidden', 'false');
        }
      });
      drawer?.setAttribute('aria-hidden', mobileMedia.matches ? 'true' : 'false');
      updatePriceRangeTrack();
      apply();
    };

    const initAllSalesPages = (root = document) => {
      if (root.matches?.('[data-sales-page]')) initSalesPage(root);
      root.querySelectorAll('[data-sales-page]').forEach(initSalesPage);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllSalesPages(), { once: true });
    } else {
      initAllSalesPages();
    }
    document.addEventListener('shopify:section:load', (event) => initAllSalesPages(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
